export default "__VITE_ASSET__19b21e11__"